(() => {
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  const payment = (principal, annualRate, months) => {
    const monthly = annualRate / 100 / 12;
    if (!monthly) return principal / months;
    return principal * monthly * Math.pow(1 + monthly, months) / (Math.pow(1 + monthly, months) - 1);
  };
  const fill = (input) => {
    const min = Number(input.min);
    const max = Number(input.max);
    const value = Number(input.value);
    input.style.setProperty('--p', `${((value - min) / (max - min)) * 100}%`);
  };
  const init = (root) => {
    const amount = root.querySelector('[data-amount]');
    const term = root.querySelector('[data-term]');
    const purpose = root.querySelector('[data-purpose]');
    const amountOut = root.querySelector('[data-amount-output]');
    const termOut = root.querySelector('[data-term-output]');
    const purposeOut = root.querySelector('[data-purpose-output]');
    const rangeOut = root.querySelector('[data-monthly-range]');
    const result = root.querySelector('[data-goo-result]');
    if (!amount || !term || !purpose || !rangeOut || !result) return;
    const lowApr = Number(root.dataset.aprLow || 8.3);
    const highApr = Number(root.dataset.aprHigh || 27.5);
    let first = true;
    const update = () => {
      const principal = Number(amount.value);
      const months = Number(term.value);
      const low = Math.round(payment(principal, lowApr, months));
      const high = Math.round(payment(principal, highApr, months));
      amountOut.textContent = money.format(principal);
      termOut.textContent = `${months} months`;
      purposeOut.textContent = `For ${purpose.value.toLowerCase()}`;
      rangeOut.textContent = `${money.format(low)} to ${money.format(high)}`;
      fill(amount);
      fill(term);
      if (!first) {
        result.classList.remove('is-morphing');
        void result.offsetWidth;
        result.classList.add('is-morphing');
        window.setTimeout(() => result.classList.remove('is-morphing'), 720);
      }
      first = false;
    };
    [amount, term, purpose].forEach((input) => input.addEventListener('input', update));
    update();
  };
  const start = () => document.querySelectorAll('[data-estimator]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
